import { render } from "./NavbarPageComponent.vue?vue&type=template&id=9205ffd8&scoped=true&ts=true"
import script from "./NavbarPageComponent.vue?vue&type=script&lang=ts"
export * from "./NavbarPageComponent.vue?vue&type=script&lang=ts"

import "./NavbarPageComponent.vue?vue&type=style&index=0&id=9205ffd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9205ffd8"]])

export default __exports__